<p>
    Protoshift is an addicting, fast paced, twitch based, arcade game filled
    with challenge, inspired by Super Hexagon. Put your mouse hand to the test
    while attempting to complete impossible levels and compete on global
    leader-boards.
</p>

<p>
    Protoshift was originally released on Steam on Jan 15, 2016. A few years
    after release I sold the Steam version to a publisher, who's account was
    taken down some time later.
</p>

<p>More info can be found at these links:</p>

<ul>
    <li>
        <a
            target="details"
            href="https://www.youtube.com/playlist?list=PLR_qFtySjuJVgakQnDBLytVb8XhpEprRY
        ">Soundtrack</a>
    </li>
    <li>
        <a target="details" href="https://steamcommunity.com/groups/Protoshift"
            >Steam Community
        </a>
    </li>
    <li>
        <a
            target="details"
            href="https://web.archive.org/web/*/https://store.steampowered.com/app/398070"
            >Steam Archive
        </a>
    </li>
    <li>
        <a target="details" href="https://steamdb.info/app/398070/">Steamdb</a>
    </li>
</ul>
